import { render } from "./syslog.vue?vue&type=template&id=2c90e424&scoped=true"
import script from "./syslog.vue?vue&type=script&lang=js"
export * from "./syslog.vue?vue&type=script&lang=js"

import "./syslog.vue?vue&type=style&index=0&id=2c90e424&lang=scss&scoped=true"

import exportComponent from "../../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c90e424"]])

export default __exports__